import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { PaymentMethod } from "../../model/payment-method";
import { USER_BILL_TYPE } from "../../pages/store-front/billing-info/type";

export type BuySolarProductDetailsState = {
	productDetailsId?: string;
	durationOfPaymentsInMonths?: number;
	installationAddress?: string;
	roofType?: number;
	numberOfFloors?: number;

	newBuySolarProductDetails?: NewBuySolarProductDetailsState;
};

export type NewBuySolarProductDetailsState = {
	productDetailsId?: string;
	roofTypeId?: number;
	numberOfFloors?: number;
	paymentMethod?: PaymentMethod;
	durationOfPaymentsInMonths?: number;
	amount?: number;
	totalAmount?: number;
	bill_type?: USER_BILL_TYPE;
};

const initialState: BuySolarProductDetailsState = {
	productDetailsId: "",
	durationOfPaymentsInMonths: undefined,
	installationAddress: undefined,
	roofType: undefined,
	numberOfFloors: undefined,
};

function extractStateFromSessionStorage(): BuySolarProductDetailsState {
	const stateFromStorage = sessionStorage.getItem("buy-solar-product-details-form");

	return stateFromStorage ? JSON.parse(stateFromStorage) : initialState;
}

function saveStateToSessionStorage(state: BuySolarProductDetailsState) {
	sessionStorage.setItem("buy-solar-product-details-form", JSON.stringify(state));
}

export const buySolarProductDetailsSlice = createSlice({
	name: "buySolarProductDetails",
	initialState: extractStateFromSessionStorage(),
	selectors: {
		buySolarProductSelector: (state: BuySolarProductDetailsState) => state,
		newBuySolarProductDetailsSelector: (state: BuySolarProductDetailsState) => state.newBuySolarProductDetails,
	},
	reducers: {
		newBuySolarProductDetails: (state, action: PayloadAction<NewBuySolarProductDetailsState>) => {
			state.newBuySolarProductDetails = action.payload;
			saveStateToSessionStorage(state);
		},
		deleteNewBuySolarProductDetails: state => {
			state.newBuySolarProductDetails = undefined;
			saveStateToSessionStorage(state);
		},
		addProductToCart: (state, action: PayloadAction<BuySolarProductDetailsState | undefined>) => {
			state.productDetailsId = action.payload?.productDetailsId;
			state.durationOfPaymentsInMonths = action.payload?.durationOfPaymentsInMonths;
			state.roofType = action.payload?.roofType;
			state.numberOfFloors = action.payload?.numberOfFloors;
			saveStateToSessionStorage(state);
		},
		addInstallationAddress: (state, action: PayloadAction<string>) => {
			state.installationAddress = action.payload;
			saveStateToSessionStorage(state);
		},
		deleteProductCart: state => {
			sessionStorage.removeItem("buy-solar-product-details-form");
			state.productDetailsId = undefined;
			state.durationOfPaymentsInMonths = undefined;
			state.roofType = undefined;
			state.installationAddress = undefined;
		},
	},
});

export const { newBuySolarProductDetails, deleteNewBuySolarProductDetails, addProductToCart, deleteProductCart, addInstallationAddress } =
	buySolarProductDetailsSlice.actions;

export const { buySolarProductSelector, newBuySolarProductDetailsSelector } = buySolarProductDetailsSlice.selectors;

export default buySolarProductDetailsSlice.reducer;
